export default {
  state: {
    segurosCita:null,
    titulares:null

  },

  mutations: {

    setSegurosCita(state, newData){
      state.segurosCita = newData
    },

    setTitularesCita(state, newData){
      state.titulares = newData
    },

    resetTitularesCita(state){
      state.titulares = null
    },
    resetSegurosCita(state){
      state.segurosCita = null
    },


  },
  
};